(function ($) {

    var SPEED = 350, // this should match the CSS transition time
        PANEL = 'nav-main-mobile-panel',
        PANEL_ACTIVE = 'nav-main-mobile-panel-active',
        PANEL_PARENT = 'nav-main-mobile-panel-parent',
        PANEL_HIGHEST = 'nav-main-mobile-panel-highest';

    //Nav-main-mobile
    if ($("#nav-main-mobile").length == 0 && $(".nav-main-item").length) {
        $(".nav-main-item.nav-main-list-trigger").css("display", "none");
    }

    bindEvents();

    function bindEvents() {
        $('body')
            .on('click', '.nav-main-list-trigger', toggleMobileMenu)
            .on('click', '.' + PANEL + ' > li > a', onMenuItemClick);
    }

    function toggleMobileMenu() {
        var $html = $('html');
        $html.toggleClass('nav-main-mobile-open');
        $html.removeClass('nav-meganav-open');
        setTransitionClass($html, 'nav-main-mobile-transition');

        var isRTL = $('html').attr('data-directionrtl') === 'true';
        var floatStart = isRTL ? 'right' : 'left';
        var floatEnd = isRTL ? 'left' : 'right';

        if ($('.nav-main-list-trigger.nav-main-item-active').length && ($('.fixed-nav-header') && $('.fixed-nav-header').length) && $html.hasClass("nav-main-mobile-open")) {
            $('.fixed-nav-header').css('position', 'fixed');
            $(".nav-main-list-trigger").css("float", floatStart);
        } else {
            $(".nav-main-list-trigger").css("float", floatEnd);
            if (!($('.nav-main-list-trigger.nav-main-item-active').length) && ($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
                $('.fixed-nav-header').css('position', 'fixed');
                $(".nav-main-list-trigger").css("float", floatEnd);
            }
        }
        // for fixed header
        if ($html.hasClass("nav-main-mobile-open") && ($('.fixed-nav-header') && $('.fixed-nav-header').length)) {
            $('.nav-main-list-trigger').attr('aria-expanded', 'true');
            $(".nav-main-list-trigger").css("float", floatStart);
        }
        else {
            $('.nav-main-list-trigger').attr('aria-expanded', 'false');
            $(".nav-main-list-trigger").css("float", floatEnd);
        }

        // for normal headers
        if ($html.hasClass("nav-main-mobile-open")) {
            $('.nav-main-list-trigger').attr('aria-expanded', 'true');
        }
        else {
            $('.nav-main-list-trigger').attr('aria-expanded', 'false');
        }

        $('.body-content *').on('focus', function () {
            var $html = $('html');
            if ($('html').hasClass('nav-main-mobile-open')) {
                $('.nav-main-list-trigger').focus();
                $html.toggleClass('nav-main-mobile-open');
                $('.nav-main-list-trigger').attr('aria-expanded', 'false');
            }
        });
    }

    function onMenuItemClick(e) {
        var $link = $(this),
            target = $link.attr('href'),
            isMenuNav = (target[0] === '#');

        if (!isMenuNav) return;

        e.preventDefault();

        if (target === '#') {
            toggleMobileMenu();
            return;
        }

        var $thisPanel = $link.closest('.' + PANEL),
            $targetPanel = $(target),
            isBackNav = ($link.parent().index() === 0);

        setActivePanel($targetPanel);
        setTransitionClass(isBackNav ? $thisPanel : $targetPanel, PANEL_HIGHEST);
    }

    function setTransitionClass(element, className) {
        element.addClass(className);
        transitionDelay(function () {
            element.removeClass(className);
        });
    }

    function transitionDelay(fn) {
        setTimeout(fn, SPEED);
    }

    function setActivePanel(panel) {
        $('.' + PANEL_ACTIVE).removeClass(PANEL_ACTIVE);
        $('.' + PANEL_PARENT).removeClass(PANEL_PARENT);
        panel.addClass(PANEL_ACTIVE);
        findParentPanel(panel).addClass(PANEL_PARENT);
    }

    function findParentPanel(childPanel) {
        var firstLink = childPanel.find('li:first-child > a'),
            parentSelector = firstLink.attr('href');
        return $(parentSelector);
    }


    $(".nav-main-search-trigger").on("click", function () {
        if ($('html').hasClass("nav-main-mobile-open")) {
            $(".nav-main-search-trigger").prop('disabled', true);
        } else {
            $(".nav-main-search-trigger").prop('disabled', false);
        }
        // sitecore changes for nav-search close button aria-label
        var ariaLabelText = $('.nav-main-search-trigger').attr('data-aria-label-close');
        var ariaLabelTextSearch = $('.nav-main-search-trigger').attr('data-aria-label-search');

        var activeElement = $('a.nav-main-item-active');
        if (activeElement.length > 0) {
            $('a.nav-main-search-trigger').removeAttr('aria-label');
            $('a.nav-main-search-trigger').attr('aria-label', ariaLabelTextSearch);
        }
        else {
            $('a.nav-main-search-trigger').removeAttr('aria-label');
            $('a.nav-main-search-trigger').attr('aria-label', ariaLabelText);
        }
    });

    function disableSearchButton() {
        if ($('html').hasClass("nav-main-mobile-open")) {
            $(".nav-main-search-trigger").prop('disabled', true);
            $('.body-content .coveo-globalsearchbox *').attr('tabindex', '-1');
        } else {
            $(".nav-main-search-trigger").prop('disabled', false);
            $('.body-content .coveo-globalsearchbox *').removeAttr('tabindex');
        }
    }

    $(".nav-main-search-trigger").on("click", disableSearchButton);


    $($("#nav-main-mobile").detach()).insertAfter($('.nav-main-bar').children().eq(0));

    $(".nav-main-mobile-back a").on('click', function () {
        setTimeout(function () {
            if ($('html').hasClass("nav-main-mobile-open")) {
                $(".nav-main-mobile-panel.nav-main-mobile-panel-menu.nav-main-mobile-panel-active li:first-child a").focus();
            }
        }, 200);
    });

    /*for PSWEP 461*/
    var lastEnteredSubmenu = "";
    var mainMenuId;
    function tabFocus(el) {
        var $parentPanel = el.closest('.nav-main-mobile-panel');
        if ($parentPanel.hasClass('nav-main-mobile-panel-active')) {
            var idValue = $parentPanel.attr("data-parent-id");
            if (idValue == '' || idValue == undefined) {
                idValue = $parentPanel.attr("id");
            }
            $parentPanel.removeClass('nav-main-mobile-panel-active');
            var $targetPanel = $('#' + idValue);
            $targetPanel.addClass('nav-main-mobile-panel-active');

            var nextItem = $(lastEnteredSubmenu).next('li').find('a');
            $(nextItem).focus();
            //$('.nav-main-mobile-panel-active li:last-child a').focus();
        }
    }
    
     $('.nav-main-mobile-panel li').on('keydown', function (e) {
        if (e.key === 'Tab' || e.keyCode === 9) {
            var val = $(this);
            var $listItems = $('.nav-main-mobile-panel-active li');
            mainMenuId = $('.nav-main-mobile-panel-active').attr('id');
            var $lastItem = $listItems.last();
            if (val.is($lastItem)) {
                e.preventDefault();
                tabFocus($lastItem);
                if (mainMenuId == 'mainmenu') {
                    toggleMobileMenu();
                    $(".nav-main-list-trigger").focus();
                }
            }
        }
        if (e.key === 'Enter' || e.keyCode === 13) {
            lastEnteredSubmenu = $(e.target).parent('li');
        }
    });
    /*for PSWEP 461*/
    $('.nav-main-search-trigger').on('focus', function () {
        if ($('html').hasClass("nav-main-mobile-open")) {
            // $(".nav-main-list-trigger").click(); /*Commenting for PSWEP 461*/
            /*for PSWEP 461*/
            if (mainMenuId == 'mainmenu') {
                $('.nav-main-mobile-panel').addClass('nav-main-mobile-panel-active');
                $(".nav-main-list-trigger").focus();
            }
            $('.nav-main-mobile-panel-active li:first-child a').focus();
            /*for PSWEP 461*/
            $('.nav-main-list-trigger').attr('aria-expanded', 'false');
        }
    });
    /* to fix whitespace pop up issue */
    $(".nav-main-mobile-panel li").on('click', function () {
        setTimeout(function () {
            if ($(".modal").hasClass("nav-main-mobile-panel-active")) {
                $("#nav-main-mobile ul:first-child").addClass("nav-main-mobile-panel-active");
            }
        }, 200);
    });

    /* to fix whitespace pop up issue */
    $('.nav-main-search-trigger').on('focus', function () {
        if ($('html').hasClass("nav-main-mobile-open")) {
            $(".nav-main-list-trigger").click();
            $(".nav-main-list-trigger").focus();
            $('.nav-main-list-trigger').attr('aria-expanded', 'false');
        }
    });

    $('.nav-main-search-trigger').on('focus', function () {
        if ($('html').hasClass("nav-meganav-open")) {
            $(".nav-icon-trigger").click();
            $(".nav-icon-trigger").focus();
        }
    });
    $('.a01-breadcrumb *').on('focus', function () {
        var $html = $('html');
        if ($('html').hasClass('nav-main-mobile-open')) {
            $('.nav-main-list-trigger').focus();
            $html.toggleClass('nav-main-mobile-open');
            $('.nav-main-list-trigger').attr('aria-expanded', 'false');
        }
    });
    
    //For bug 22657 in WEP 3, so that it doesn't affect ticker. The ".body-content *" selector is not specific enough, so if all code is bundled together, it affects any child of body-content in this case causing all svgs and paths to be keyboard focusable.
    function addFocusHandler() {
        if ($('html').hasClass('nav-main-mobile-open')) {
            $('.body-content *').on('focus', function () {
                $('.nav-main-list-trigger').focus();
                $('html').toggleClass('nav-main-mobile-open');
                $('.nav-main-list-trigger').attr('aria-expanded', 'false');
            });
        } 
    }    
    addFocusHandler();
    $(window).resize(function () {
        addFocusHandler();
    });
    $('.component.logo *').on('focus', function () {
        var $html = $('html');
        if ($('html').hasClass('nav-main-mobile-open')) {
            $('.nav-main-list-trigger').focus();
            $html.toggleClass('nav-main-mobile-open');
            $('.nav-main-list-trigger').attr('aria-expanded', 'false');
        }
    });



}(window.jQuery));